import { render, staticRenderFns } from "./ext_otp_code.vue?vue&type=template&id=2239f641&scoped=true&"
import script from "./ext_otp_code.vue?vue&type=script&lang=js&"
export * from "./ext_otp_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2239f641",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2239f641')) {
      api.createRecord('2239f641', component.options)
    } else {
      api.reload('2239f641', component.options)
    }
    module.hot.accept("./ext_otp_code.vue?vue&type=template&id=2239f641&scoped=true&", function () {
      api.rerender('2239f641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/glovo/external_glovo/ext_otp_code.vue"
export default component.exports